import React, { Component } from 'react';
import AnalogClock, { Themes } from 'react-analog-clock';
import './index.css';

const WIDTH = 100;
const GMTOFFSET_LONDON = '0';
const GMTOFFSET_PARIS = '+1';
const GMTOFFSET_ROME = '+2';

export default class Clocks extends Component {
  render () {
    return (
      <div className="comp-clocks">
        <div className="comp-clocks__clock m-r-small">
          <div className="comp-clocks__clock__text">
            <span>Iasi</span>
          </div>
          <AnalogClock theme={Themes.light} width={WIDTH} />
        </div>
        <div className="comp-clocks__clock m-r-small">
          <div className="comp-clocks__clock__text">
            <span>London</span>
          </div>
          <AnalogClock theme={Themes.light} width={WIDTH} gmtOffset={GMTOFFSET_LONDON}/>
        </div>
        <div className="comp-clocks__clock m-r-small">
          <div className="comp-clocks__clock__text">
            <span>Paris</span>
          </div>
          <AnalogClock theme={Themes.light} width={WIDTH} gmtOffset={GMTOFFSET_PARIS}/>
        </div>
        <div className="comp-clocks__clock m-r-small">
          <div className="comp-clocks__clock__text">
            <span>Roma</span>
          </div>
          <AnalogClock theme={Themes.light} width={WIDTH} gmtOffset={GMTOFFSET_ROME}/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/clocks/index.js